export const LISTING_TGB_TRACKING_LABELS = {
  map: {
    show: 'Listing_show_TGB',
    click: 'Listing_click_TGB',
  },
  serp: {
    show: 'Listing_show_TGB',
    click: 'Listing_click_TGB',
  },
};

export const LISTING_TGB_SLIDER_TRACKING_LABELS = {
  map: null,
  serp: {
    show: 'Listing_show_slider_TGB',
    click: 'Listing_click_slider_TGB',
  },
};

// TODO: уточнить точные имена событий у аналитика
export const LISTING_PARALLAX_TRACKING_LABELS = {
  map: {
    show: 'Listing_show_parallax',
    click: 'Listing_click_parallax',
  },
  serp: {
    show: 'Listing_show_parallax',
    click: 'Listing_click_parallax',
  },
};
